import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { noop } from 'lodash-es';
import { personalizedSearchEntities } from 'site-modules/personalized-search/prop-types/prop.types';
import { COMPONENTS } from 'site-modules/personalized-search/constants/components';
import { SearchRenderer } from 'site-modules/personalized-search/search-renderer/search-renderer';

import 'client/site-modules/personalized-search/styles.scss';

export function Anchor({ componentParams, componentPath, onRendered = noop }) {
  useEffect(() => {
    onRendered();
  }, [onRendered]);

  return (
    <div className="base-inner-width px-1 px-md-0_5 px-lg-0 mx-md-auto">
      {componentParams?.map((paramsItem, idx) => {
        const { make, model, year } = paramsItem.anchorItem;
        const key = `${make.name}-${model.name}-${year}`;
        return (
          <SearchRenderer
            key={key}
            componentParams={paramsItem}
            componentPath={componentPath}
            parentComponentName={COMPONENTS.ANCHOR}
            order={idx + 1}
          />
        );
      })}
    </div>
  );
}

Anchor.propTypes = {
  componentParams: PropTypes.arrayOf(
    PropTypes.shape({
      components: PropTypes.arrayOf(PropTypes.string),
      anchorItem: personalizedSearchEntities.headerComponentParams,
    })
  ).isRequired,
  componentPath: PropTypes.string.isRequired,
  onRendered: PropTypes.func,
};
